var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfRegVerifyEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 101.25,
    viewBox: "0 0 180 101.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verify_email_icon",
    "data-name": "Verify email icon",
    transform: "translate(90 50.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42065",
    "data-name": "Group 42065",
    transform: "translate(-90 -50.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123756",
    "data-name": "Path 123756",
    d: "M17.9,53.227a32.22,32.22,0,0,1-.739-6.144l2.955-.072a29.207,29.207,0,0,0,.671,5.579Zm2.28-9.033-2.95-.2a36.1,36.1,0,0,1,.95-6.083l2.872.7A33.273,33.273,0,0,0,20.181,44.194Zm1.654-8.31-2.807-.927A41.243,41.243,0,0,1,21.384,29.3l2.638,1.335A38.335,38.335,0,0,0,21.836,35.885Zm143.821-3.973c-1.642-1.048-3.322-2.088-4.992-3.088l1.519-2.536c1.695,1.015,3.4,2.069,5.065,3.133ZM25.4,28.14l-2.536-1.518a44.834,44.834,0,0,1,3.489-5.015l2.307,1.849A41.925,41.925,0,0,0,25.4,28.14Zm132.739-.806c-1.693-.98-3.416-1.945-5.122-2.867l1.406-2.6c1.73.936,3.479,1.914,5.2,2.908Zm-7.713-4.243c-1.739-.907-3.5-1.794-5.243-2.637l1.29-2.66c1.765.855,3.555,1.756,5.319,2.675Zm-119.907-1.8-2.178-2c.721-.787,1.477-1.555,2.246-2.283.693-.657,1.419-1.307,2.159-1.931l1.905,2.259c-.7.587-1.378,1.2-2.031,1.817C31.9,19.834,31.192,20.552,30.517,21.288Zm112.015-2.095c-1.763-.822-3.565-1.628-5.355-2.4l1.167-2.717c1.817.781,3.646,1.6,5.436,2.434Zm-8.06-3.534c-1.794-.738-3.63-1.462-5.458-2.148l1.04-2.767c1.858.7,3.723,1.432,5.545,2.183ZM36.9,15.546l-1.776-2.363a57.029,57.029,0,0,1,5.041-3.374l1.514,2.54A54.084,54.084,0,0,0,36.9,15.546ZM126.26,12.5c-1.839-.658-3.707-1.294-5.553-1.891l.908-2.812c1.876.605,3.774,1.252,5.641,1.921Zm-82.074-1.56L42.8,8.327c1.749-.927,3.59-1.793,5.471-2.575l1.135,2.73C47.613,9.229,45.856,10.056,44.187,10.939ZM117.909,9.73c-1.862-.569-3.758-1.115-5.636-1.624l.773-2.853c1.908.517,3.836,1.072,5.726,1.65ZM52.1,7.431,51.088,4.654c1.858-.679,3.792-1.294,5.747-1.83l.782,2.85C55.74,6.19,53.884,6.78,52.1,7.431Zm57.335-.07c-1.914-.486-3.833-.939-5.705-1.347l.631-2.888c1.9.415,3.856.876,5.8,1.371Zm-8.572-1.945C98.919,5.029,96.98,4.684,95.1,4.39l.458-2.921c1.915.3,3.893.654,5.88,1.048Zm-40.44-.451-.667-2.88c1.934-.448,3.926-.828,5.918-1.131l.444,2.923C64.2,4.168,62.286,4.534,60.425,4.965Zm31.785-1c-1.958-.264-3.911-.48-5.8-.642L86.658.38c1.941.166,3.942.387,5.948.658ZM69,3.5,68.662.559l.156-.018C69.988.407,71.948.183,74.659.07l.122,2.954c-2.6.108-4.5.325-5.627.454Zm14.5-.38c-1.841-.107-3.655-.16-5.394-.16h-.423L77.669,0h.444c1.788,0,3.66.056,5.557.165Z",
    transform: "translate(-5.095)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42064",
    "data-name": "Group 42064",
    transform: "translate(123.316 10.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123757",
    "data-name": "Path 123757",
    d: "M209.9,23.27l-3.2,6.553,34.662,19.144Z",
    transform: "translate(-184.681 -17.104)",
    fill: "#aa7bc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123758",
    "data-name": "Path 123758",
    d: "M202.926,43.616l2.642,6.919L238.7,54.12Z",
    transform: "translate(-183.559 -23.144)",
    fill: "#aa7bc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123759",
    "data-name": "Path 123759",
    d: "M232.067,50.525,175.382,36.989l18.364-8.472Z",
    transform: "translate(-175.382 -18.662)",
    fill: "#bb95cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123760",
    "data-name": "Path 123760",
    d: "M211.251,20.666l31.464,25.7-20-31.863Z",
    transform: "translate(-186.031 -14.501)",
    fill: "#bb95cf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_123761",
    "data-name": "Path 123761",
    d: "M19.97,57.2H91.532v61.033H0V79.711C0,67.277,8.941,57.2,19.97,57.2Z",
    transform: "translate(0 -16.981)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26607",
    "data-name": "Rectangle 26607",
    width: 86.541,
    height: 7.517,
    transform: "translate(0 93.733)",
    fill: "#008dc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123762",
    "data-name": "Path 123762",
    d: "M121.747,57.2c11.029,0,19.97,10.079,19.97,22.513v38.52h-39.94V79.711C101.778,67.277,110.719,57.2,121.747,57.2Z",
    transform: "translate(-30.215 -16.981)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26608",
    "data-name": "Rectangle 26608",
    width: 4.077,
    height: 51.318,
    transform: "translate(63.827 20.749)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123763",
    "data-name": "Path 123763",
    d: "M66.022,41.062h18.9V29.51h-18.9L71.8,35.286Z",
    transform: "translate(-19.6 -8.761)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26609",
    "data-name": "Rectangle 26609",
    width: 29.638,
    height: 10.192,
    transform: "translate(52.463 91.057)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26610",
    "data-name": "Rectangle 26610",
    width: 29.638,
    height: 10.192,
    transform: "translate(74.989 75.175) rotate(-154.399)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123764",
    "data-name": "Path 123764",
    d: "M83.887,81.342,81.7,83.315a1.232,1.232,0,0,0-.121,1.706l1.249,1.5-2.37-.564a1.66,1.66,0,0,0-1.715.621l-1.986,2.654,9.15,4.517,4.785-9.057Z",
    transform: "translate(-22.787 -24.148)",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123765",
    "data-name": "Path 123765",
    d: "M102.465,62.523,85.813,77.5a1.542,1.542,0,0,0-.116,2.18l26.034,28.941a1.544,1.544,0,0,0,2.18.115l16.652-14.98a1.543,1.543,0,0,0,.116-2.18l-26.034-28.94A1.543,1.543,0,0,0,102.465,62.523Z",
    transform: "translate(-25.324 -18.444)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123766",
    "data-name": "Path 123766",
    d: "M109.49,62.524l-.525.473,2,22.061a4.919,4.919,0,0,0,3.859,4.364l22.243,4.81.526-.473a1.545,1.545,0,0,0,.115-2.181L111.671,62.639A1.545,1.545,0,0,0,109.49,62.524Z",
    transform: "translate(-32.349 -18.444)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123767",
    "data-name": "Path 123767",
    d: "M96.32,137.148l5.2-5.388L94.773,129.5H78.078Z",
    transform: "translate(-23.179 -38.446)",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123768",
    "data-name": "Path 123768",
    d: "M76.437,91.647l-7.713,21.028a1.544,1.544,0,0,0,.917,1.982l36.546,13.4a1.543,1.543,0,0,0,1.981-.918l7.713-21.029a1.543,1.543,0,0,0-.917-1.981l-36.547-13.4A1.543,1.543,0,0,0,76.437,91.647Z",
    transform: "translate(-20.374 -26.907)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123769",
    "data-name": "Path 123769",
    d: "M79.554,91.647l-.426,1.163,12.265,18.067a4.918,4.918,0,0,0,5.451,2.052l21.91-6.151.244-.664a1.545,1.545,0,0,0-.918-1.981l-36.544-13.4A1.545,1.545,0,0,0,79.554,91.647Z",
    transform: "translate(-23.491 -26.907)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123770",
    "data-name": "Path 123770",
    d: "M146.13,73.433c10.7,2.673,13.84,13.222,8.882,24.623l-13.295,24.829h-39.94L119,88.754C123.956,77.351,135.915,70.882,146.13,73.433Z",
    transform: "translate(-30.215 -21.636)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123771",
    "data-name": "Path 123771",
    d: "M146.13,73.433c10.7,2.673,13.84,13.222,8.882,24.623l-13.295,24.829h-39.94L119,88.754C123.956,77.351,135.915,70.882,146.13,73.433Z",
    transform: "translate(-30.215 -21.636)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123772",
    "data-name": "Path 123772",
    d: "M163.7,75.47c3.409,5.529,3.417,13.313-.133,21.476l-14.3,26.709h6.552l13.295-24.829C173.483,88.77,171.552,79.381,163.7,75.47Z",
    transform: "translate(-44.312 -22.405)",
    fill: "#008dc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123773",
    "data-name": "Path 123773",
    d: "M205.157,102.566l-.046-4-3.321-2.229a.549.549,0,0,1,.13-.977l3.789-1.28,1.093-3.847a.549.549,0,0,1,.97-.178l2.389,3.208,4-.148a.549.549,0,0,1,.469.867l-2.313,3.262L213.69,101a.55.55,0,0,1-.68.714l-3.818-1.191-3.146,2.469A.549.549,0,0,1,205.157,102.566Z",
    transform: "translate(-59.834 -26.67)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123774",
    "data-name": "Path 123774",
    d: "M176.742,127.075a1.3,1.3,0,0,0,1.82-.941,5.887,5.887,0,0,0-7.149-6.872c-1.13.269-2.153.863-3.254,1.233a3.885,3.885,0,0,1-3.357-.162c-1.338-.894-1.5-2.8-2.488-4.071a3.628,3.628,0,0,0-5.139-.6,1.3,1.3,0,0,0-.078,1.967l.11.1a1.3,1.3,0,0,0,1.384.248,1.624,1.624,0,0,1,.881-.089,1.735,1.735,0,0,1,1.109.98c.23.456.343.96.532,1.434a5.7,5.7,0,0,0,3.388,3.144,8.211,8.211,0,0,0,4.694.154,26.7,26.7,0,0,1,2.947-.744,3.364,3.364,0,0,1,2.83.778,2.04,2.04,0,0,1,.517,1.763,1.269,1.269,0,0,0,.693,1.416C176.369,126.9,176.556,126.989,176.742,127.075Z",
    transform: "translate(-46.515 -34.099)",
    fill: "#ff7f32"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfRegVerifyEmailIcon);
export default __webpack_public_path__ + "static/media/SelfReg-VerifyEmailIcon.1f1a52788dacd2d8db17897037bd8bc0.svg";
export { ForwardRef as ReactComponent };